import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import { NotificationAction } from "../../../../store/actions";

import Spacer from "../../../spacer/spacer";

import NotifiMainInbox from "./notifimaininbox";
import Loader from "../../../loader/loader";
import images from "../../../../assets";

import "./styles.css";

const NotificationNavs = () => {
  const dispatch = useDispatch();

  const { notifications, isLoading } = useSelector(
    (state) => state?.notifications
  );

  const now = moment();
  const newNotifications = notifications?.filter((item) =>
    moment(item?.createdAt).isAfter(now.clone().subtract(24, "hours"))
  );
  const earlierNotifications = notifications?.filter((item) =>
    moment(item?.createdAt).isBefore(now.clone().subtract(24, "hours"))
  );

  const handleUpdate = () => {
    dispatch(NotificationAction.markAsRead());
  };

  return (
    <div className="notification-area">
      <div className="notify-heading">
        <div className="notifi-heading-text">Notifications</div>
        <div
          className="notifi-sub-heading cursor-pointer p-2 border border-secondary rounded-lg"
          onClick={handleUpdate}
        >
          Mark all as read
        </div>
      </div>
      <div className="notifi-separator" />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="max-h-[600px] overflow-y-auto">
          <div className="notifi-content-area">
            {notifications?.length === 0 && (
              <div className="flex flex-col justify-center items-center p-6 w-full gap-4">
                <img
                  src={images.noNotificationIcon}
                  alt="no notifications"
                  className="h-[120px]"
                />
                <div className="text-basePrimary font-bold text-[24px] lg:text-[24px]">
                  No Notifications Yet
                </div>
                <p className="text-[14px] text-center max-w-[500px]">
                  You don’t have any notifications yet. Once you start exploring
                  and connecting, we’ll keep you updated right here.
                </p>
              </div>
            )}
            {newNotifications?.length > 0 && (
              <>
                <div className="notifi-content-title">New</div>
                {newNotifications.map((item, index) => (
                  <NotifiMainInbox
                    title={item?.title}
                    subText={item?.description}
                    route={item?.actionRoute}
                    time={moment(item?.createdAt).fromNow()}
                    pinkColor={item?.status === "unread" ? "new" : null}
                    className={
                      item?.status === "unread" || item?.status === "seen"
                        ? "notifi-unread"
                        : "notifi-read"
                    }
                    key={index}
                    id={item?.id}
                  >
                    <img
                      className="notifi-profile-img"
                      src={item?.image ?? images.notificationIcon}
                      alt=""
                    />
                  </NotifiMainInbox>
                ))}
              </>
            )}

            {earlierNotifications?.length > 0 && (
              <>
                <div className="notifi-content-title">Earlier</div>
                {earlierNotifications.map((item, index) => (
                  <NotifiMainInbox
                    title={item?.title}
                    subText={item?.description}
                    route={item?.actionRoute}
                    time={moment(item?.createdAt).fromNow()}
                    pinkColor={item?.status === "unread" ? "new" : null}
                    className={
                      item?.status === "unread" || item?.status === "seen"
                        ? "notifi-unread"
                        : "notifi-read"
                    }
                    key={index}
                    id={item?.id}
                  >
                    <img
                      className="notifi-profile-img"
                      src={item?.image ?? images.notificationIcon}
                      alt=""
                    />
                  </NotifiMainInbox>
                ))}
              </>
            )}

            <Spacer height="10px" />
          </div>
        </div>
      )}
      <div className="notifi-see-all">
        <Link to={"/notifications"}>
          <div className="notifi-see-all-btn">See all</div>
        </Link>
      </div>
      <Spacer height="10px" />
    </div>
  );
};

export default NotificationNavs;
